import { HttpClient } from "@angular/common/http";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LicenseTypeService = /** @class */ (function () {
    function LicenseTypeService(_httpClient) {
        this._httpClient = _httpClient;
    }
    LicenseTypeService.prototype.loadLicenseTypes = function () {
        return this._httpClient.get("api/licenseTypes").toPromise();
    };
    LicenseTypeService.ngInjectableDef = i0.defineInjectable({ factory: function LicenseTypeService_Factory() { return new LicenseTypeService(i0.inject(i1.HttpClient)); }, token: LicenseTypeService, providedIn: "root" });
    return LicenseTypeService;
}());
export { LicenseTypeService };
